export const formatPrice = (cents: number): string => {
  if (cents === -1) return "Custom";
  if (cents === 0) return "Free";
  return `$${(cents / 100).toFixed(0)}`;
};
